import {
	Game, GinRummyGameUI, Statistics, UserComputer,
} from 'gin-rummy-game-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { PageTitle } from './PageTitle.jsx';

import { AppContext } from '../AppContext';
import { MultiplayerGameManager } from '../services/MultiplayerGameManager.js';

const GameController = () => {
	const app = React.useContext(AppContext);
	const { level, mode } = useParams();
	const phaserGameRef = React.useRef(null);
	const gameRef = React.useRef(null);
	const { t } = useTranslation();

	//https://www.devauthority.com/react/using-pixi-js-with-react-functional-components-hooks/
	//https://stackoverflow.com/questions/75710343/react-18-and-pixijs-7
	React.useEffect(() => {
		const createGame = async () => {
			if (phaserGameRef.current) {
				return;
			}

			const isOnline = mode === 'Online';

			let room;
			let game;
			let userForLocal;

			if (isOnline) {
				room = app.multiplayer.getRoomById(level);

				if (room?.state) {
					//gameManager = new MultiplayerGameManager(room);
					const players = room.state.players.toJSON();
					const playerInfo = players[room.sessionId];

					if (!playerInfo) {
						throw new Error(`Player ${room.sessionId} not in players object: "${JSON.stringify(players)}"`);
					}

					// localPlayer = playerInfo.position ?? 2;
					game = new MultiplayerGameManager(room);

					for (const [sessionId, playerObj] of Object.entries(players)) {
						const user = new UserComputer(playerObj.name, sessionId, playerObj.avatar, 'Human');
						if (sessionId === room.sessionId) {
							userForLocal = user;
						}

						game.joinGame(user);
					}

					room.onLeave((code) => {
						if (code === 4111) {
							app.multiplayer.leaveGameRooms();
							app.showNotification(t('Removed from the game for inactivity'));
							app.navigate('Online');
						}
					});

				}
			} else {

				//Create Users - note: could be done on the app layer

				let user1 = new UserComputer('Player', 1, '', 'Human');
				let user2 = new UserComputer('Joey', -1, '', level, 600);
				if (mode === 'Test') {
					const delay = 30;
					user1 = new UserComputer('Player', 1, '', 'Test', 30);
					user2 = new UserComputer('Joey', -1, '', level, delay);
				}

				//Create Game Core - note: could be done on the app layer
				game = new Game();
				game.joinGame(user1);
				game.joinGame(user2);
				userForLocal = user1;
			}

			game.startGame();
			game.on('roundStageChanged', (_data) => {
				const roundStage = game.gameState.roundStage;
				if (roundStage === 'gameOver') {
					saveStats(game.gameState);
				}
			});

			console.log('created game is', game);

			//Create Game UI
			const gameUI = new GinRummyGameUI();
			await gameUI.create('game-canvas1', null, null);
			await gameUI.loadGame(game, userForLocal);
			gameUI.gameScene.on('Quit', () => {
				app.navigate('Online');
			});

			gameRef.current = game;
			phaserGameRef.current = gameUI;
			phaserGameRef.current.gameScene.audio.isMuted = app?.userdata?.isMuted ?? false;
		};

		createGame();
		return () => {
			if (!phaserGameRef.current) {
				return;
			}

			phaserGameRef.current.destroy(true);
			phaserGameRef.current = null;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	React.useEffect(() => {
		if (phaserGameRef?.current?.gameScene?.audio) {
			phaserGameRef.current.gameScene.audio.isMuted = app?.userdata?.isMuted;
		}

	}, [app?.userdata?.isMuted]);

	//save state function
	const saveStats = (gameState) => {

		const userdata = app?.userdata || {};
		const statistics = new Statistics();
		statistics.updateMatchStats(userdata, gameState);
		app.save();

		//check for achievements
		app.achievements.checkForAchievementAndReward(app.userdata, app.userdata);

	};

	return (

		<div id="Game" className="page noAnimate activePage">
			<div className="gamePageWrapper" >
				<PageTitle className="title-separator" shouldShowVolume />
				<div id="game-canvas1" className="gameDiv" style={{
					flex: ' 1 1 auto',
				}}>
				</div>
			</div>
		</div>
	);
};

export default GameController;
